import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, tap } from 'rxjs';
import { AuthResult, ChangePasswordRequest, LoginRequest, MeResponse } from '../models/auth.model';
import { apiBase } from './api-config';

const TOKEN_KEY = 'ac_token';

@Injectable({ providedIn: 'root' })
export class AuthService {
  private http = inject(HttpClient);
  private url = `${apiBase}/auth`;

  login(request: LoginRequest): Observable<AuthResult> {
    return this.http.post<AuthResult>(`${this.url}/login`, request).pipe(
      tap(result => this.storeToken(result.token))
    );
  }

  logout(): Observable<void> {
    return this.http.post<void>(`${this.url}/logout`, {}).pipe(
      tap(() => this.clearToken())
    );
  }

  me(): Observable<MeResponse> {
    return this.http.get<MeResponse>(`${this.url}/me`);
  }

  changePassword(request: ChangePasswordRequest): Observable<void> {
    return this.http.post<void>(`${this.url}/change-password`, request);
  }

  getToken(): string | null {
    return localStorage.getItem(TOKEN_KEY);
  }

  isAuthenticated(): boolean {
    const token = this.getToken();
    if (!token) return false;
    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      return payload.exp > Date.now() / 1000;
    } catch {
      return false;
    }
  }

  private storeToken(token: string): void {
    localStorage.setItem(TOKEN_KEY, token);
  }

  clearToken(): void {
    localStorage.removeItem(TOKEN_KEY);
  }
}
